import React from "react";
import { Button, Modal } from "antd";
import warningLogo from "../../../../assets/images/svg/warning_logo.svg";
import "./styles.css";

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  itemType,
  itemName
}) => {
  return (
    <Modal
      open={isOpen}
      footer={null}
      closable={false}
      className="delete-confirmation-modal"
      style={{ top: 60 }}
    >
      <div className="delete-modal-container">
        {/* Close button */}
        <button
          className="delete-close-btn"
          onClick={onClose}
        >
          ×
        </button>

        {/* Warning Icon */}
        <div className="delete-icon-container">
          <img
            src={warningLogo}
            alt="Warning"
            className="delete-icon-img"
          />
        </div>

        {/* Message */}
        <p className="delete-message">
          Are you sure you want to delete this {itemType}?
          {itemName && <span className="delete-item-name"> "{itemName}"</span>}
        </p>

        {/* Buttons */}
        <div className="delete-buttons-container">
          <Button
            className="delete-btn-outline"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="delete-btn-danger"
            onClick={onConfirm}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
